import { TemplateElement, html, defineElement } from '@webtides/element-js';
import portionsStore from './recipe-ingredients-portion-store.js';
import style from './recipe-ingredients-list.css';
import { svgUse } from '../../webresources-sources/js/util/icon.js';
import { when } from '../../webresources-sources/js/util/directives';

/**
 * @property {'recipe' | 'step'} variant
 * @property {array} ingredients
 * @property {PortionsStore} portionsStore
 */
export default class RecipeIngredientsList extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            variant: 'recipe',
            ingredients: [],
            portionsStore,
        };
    }

    connected() {}

    /**
     * @param {number} amount
     * @return {number}
     */
    calculatedAmount(amount) {
        const parsedAmount = parseFloat(amount.replace(',', '.'));
        return portionsStore.portions * parsedAmount;
    }

    template() {
        return this.variant === 'recipe' ? this.verticalTemplate() : this.horizontalTemplate();
    }

    verticalTemplate() {
        return html`<ul class="vertical list-unstyled">
            ${this.ingredients.map(
                (ingredient) =>
                    html`
                        <li>
                            <span class="ingredient-measurement">
                                ${ingredient.amount ? this.calculatedAmount(ingredient.amount) : ''}
                                ${ingredient.measurement}
                            </span>
                            ${svgUse({
                                name: 'icon-bullet-point',
                                cssClasses: 'icon-bullet-point mx-8',
                            })}<span class="ingredient-name">${ingredient.ingredientName}</span>
                        </li>
                    `,
            )}
        </ul>`;
    }

    horizontalTemplate() {
        const hasIngredients = this.ingredients.length > 0;
        return html`
            <div class="d-flex align-items-start gap-16">
                ${when(
                    hasIngredients,
                    html` ${svgUse({
                        name: 'icon-grocery-bag',
                        cssClasses: 'icon-grocery-bag icon-size-24',
                    })}`,
                )}
                <ul class="horizontal list-unstyled">
                    ${this.ingredients.map(
                        (ingredient, index) =>
                            html`
                                <li class="horizontal-item">
                                    <span class="amount"
                                        >${ingredient.amount ? this.calculatedAmount(ingredient.amount) : ''}
                                        ${ingredient.measurement}</span
                                    >
                                    ${ingredient.ingredientName}
                                    ${index < this.ingredients.length - 1
                                        ? html`
                                              ${svgUse({
                                                  name: 'icon-dot',
                                                  cssClasses: 'icon-dot',
                                              })}
                                          `
                                        : null}
                                </li>
                            `,
                    )}
                </ul>
            </div>
            ${when(
                hasIngredients,
                html` ${svgUse({
                    name: 'icon-separator-horizontal',
                    cssClasses: 'icon-separator-horizontal icon-size-24',
                })}`,
            )}
        `;
    }
}

defineElement('recipe-ingredients-list', RecipeIngredientsList);
